const W = 380, H = 130;
const pts = Array.from({ length: 60 }, (_, i) => {
  const t = i / 59;
  const y = 0.08 + 0.78 * Math.pow(t, 1.35) + 0.035 * Math.sin(i * 0.9) + 0.02 * Math.sin(i * 2.3);
  return [6 + t * (W - 12), H - 8 - y * (H - 20)];
});
const line = pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
const area = `${line} L${W - 6},${H} L6,${H} Z`;
const last = pts[pts.length - 1];

const METRICS = [
  ["Net P&L", "+₹4,82,150", "text-[var(--tn-green)]"],
  ["CAGR", "34.8%", "text-[var(--tn-green)]"],
  ["Max drawdown", "-12.4%", "text-[var(--tn-red)]"],
  ["Win rate", "61.2%", "text-[var(--tn-text)]"],
];

const ORDERS = [
  ["09:22", "NIFTY 24800 CE", "BUY", "+8,320"],
  ["10:05", "BANKNIFTY FUT", "SELL", "-2,150"],
  ["11:48", "RELIANCE", "BUY", "+5,640"],
];

export const Terminal = () => (
  <figure data-testid="hero-terminal-mockup" className="w-full">
    <div className="rounded-xl border border-[#1f2937] bg-[#0a0e15] overflow-hidden font-mono shadow-[0_30px_80px_-30px_rgba(34,211,238,0.25)]">
      <div className="flex items-center justify-between px-4 h-11 border-b border-[var(--tn-line)] bg-[#0d131c]">
        <div className="flex items-center gap-3">
          <span className="flex gap-1.5">
            <i className="w-2.5 h-2.5 rounded-full bg-[#f87171]" />
            <i className="w-2.5 h-2.5 rounded-full bg-[#facc15]" />
            <i className="w-2.5 h-2.5 rounded-full bg-[#a3e635]" />
          </span>
          <span className="text-[11px] text-[var(--tn-muted)]">strategy · nifty-orb-ai · paper</span>
        </div>
        <span className="text-[10px] text-[var(--tn-green)] border border-[rgba(163,230,53,0.35)] rounded-full px-2.5 py-1 flex items-center gap-1.5">
          <i className="w-1.5 h-1.5 rounded-full bg-[var(--tn-green)] tn-pulse" /> LIVE
        </span>
      </div>
      <div className="px-4 pt-4 pb-2">
        <div className="flex justify-between text-[11px]">
          <span className="text-[var(--tn-muted)]">Equity curve · 1D</span>
          <span className="text-[var(--tn-green)]">+52.4% backtest</span>
        </div>
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-36 mt-2" preserveAspectRatio="none">
          <defs>
            <linearGradient id="eq" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#22d3ee" stopOpacity="0" />
            </linearGradient>
          </defs>
          {[0.25, 0.5, 0.75].map((g) => (
            <line key={g} x1="0" x2={W} y1={H * g} y2={H * g} stroke="#1a222e" strokeDasharray="3 4" />
          ))}
          <path d={area} fill="url(#eq)" />
          <path d={line} fill="none" stroke="#22d3ee" strokeWidth="1.8" className="tn-draw" />
          <circle cx={last[0]} cy={last[1]} r="3" fill="#a3e635" />
        </svg>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 border-y border-[var(--tn-line)]">
        {METRICS.map(([k, v, c], i) => (
          <div key={k} className={`px-4 py-3.5 border-[var(--tn-line)] ${i ? "sm:border-l" : ""} ${i % 2 ? "border-l" : ""} ${i > 1 ? "border-t sm:border-t-0" : ""}`}>
            <div className="text-[10px] uppercase tracking-wider text-[var(--tn-muted)]">{k}</div>
            <div className={`text-[15px] mt-1.5 ${c}`}>{v}</div>
          </div>
        ))}
      </div>
      <ul>
        {ORDERS.map(([t, s, side, pnl]) => (
          <li key={t} className="flex items-center justify-between px-4 h-11 border-b last:border-b-0 border-[var(--tn-line)] text-[11px]">
            <span className="flex gap-4"><span className="text-[var(--tn-muted)]">{t}</span><span>{s}</span></span>
            <span className="flex items-center gap-4">
              <span className={`text-[9px] px-1.5 py-0.5 rounded border ${side === "BUY" ? "text-[var(--tn-green)] border-[rgba(163,230,53,0.4)]" : "text-[var(--tn-red)] border-[rgba(248,113,113,0.4)]"}`}>{side}</span>
              <span className={pnl.startsWith("+") ? "text-[var(--tn-green)]" : "text-[var(--tn-red)]"}>{pnl}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
    <figcaption className="text-center text-[11px] font-mono text-[var(--tn-muted)] mt-3">
      Illustrative preview — example numbers, not verified returns
    </figcaption>
    <p className="sr-only">
      Illustrative mock-up of the Trading Nifty paper-trading terminal showing a sample strategy equity curve, headline metrics and order log. All figures shown are examples and do not represent actual or expected returns.
    </p>
  </figure>
);
